/**
 * 常量配置
 */
export const TOKEN_KEY = "ai-chat-token"; //Token 存储键名
export const USER_INFO_KEY = "ai-chat-tourist-info"; //用户信息
export const UDID_KEY = "ai-chat-udid"; //设备唯一标识符
export const APP_ID_KEY = "ai-chat-app-id"; //应用ID
export const IS_LOGGED_IN_KEY = "ai-chat-is-logged-in"; //用户是否已登录
export const SERVICE_TIME_KEY = "ai-chat-service-time"; //服务时间
export const IS_COMPLETE_INFO_KEY = "ai-chat-is-complete-info"; //是否完善信息
export const SEARCH_HISTORY_KEY = "ai-chat-search-history"; //搜索历史
export const IS_EDIT_INFO_KEY = "ai-chat-is-edit-info"; //是否编辑信息
export const DETAIL_INFO_KEY = "ai-chat-detail-info-key"; //详情信息
export const CHAT_EXPENSES_KEY = "ai-chat-chat-expenses-key"; //单条聊天数据、
export const IS_EMBEDDED_H5_KEY = "ai-chat-is-embedded-h5"; //是否嵌入H5
export const IS_THINKING_KEY = "ai-chat-is-thinking"; //是否思考
export const MSG_IMG_COST_KEY = "ai-chat-msg-img-cost"; //图片消息费用
export const DEVICE_INFO_KEY = "ai-chat-device-info"; //设备信息
